import http from "../../utils/http-common";

export function processFrameworkArtifact(params) {
  return http
    .post("/registry/process_framework_artifact", params)
    .then((r) => r.data);
}

export function analyzeArtifact(params) {
  return http.post("/registry/analyze_artifact", params).then((r) => r.data);
}

export function processSourceArtifact(params) {
  return http
    .post("/registry/process_source_artifact", params)
    .then((r) => r.data);
}
export function processEmulatorResourceStorage(params) {
  return http
    .post("/registry/process_emulator_resource_artifact", params)
    .then((r) => r.data);
}
